<template>
  <div>
    <v-hover>
      <template v-slot:default="{ isHovering, props }">
        <v-btn
          @click="childFunction"
          v-bind="props"
          class="rounded-pill text-capitalize font-weight-bold px-6 py-4"
          elevation="0"
          size="x-large"
          style="letter-spacing: 0; height: auto; min-width: 150px"
          :class="
            invert
              ? isHovering
                ? 'text-white'
                : 'bg-white text-primary-darken-1'
              : 'bg-primary text-white'
          "
          :color="isHovering ? 'secondary' : ''"
        >
          <slot />
          <v-icon
            v-if="icon"
            icon="mdi mdi-arrow-up"
            class="ml-1"
            style="transform: rotate(45deg)"
          />
        </v-btn>
      </template>
    </v-hover>
  </div>
</template>

<script>
export default {
  name: "Button",
  props: {
    icon: {
      type: Boolean,
      default: true,
    },
    invert: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    childFunction() {
      let argument = null;
      this.$emit("parentFunction", argument);
    },
  },
};
</script>
